import { Link } from 'gatsby';
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image';
import React from 'react'
import styled from 'styled-components'
import Rects from './Svg/Rects';

const Wrap = styled.div`
    background: #39394C;
    margin-top: 118px;
    
`
const Wrapper = styled.div`
    margin: 0 40px;
    padding-bottom: 4rem;
    @media screen and (max-width:740px) {
        margin: 0 16px;
    }
`
const TitleWrap  = styled.div`
        display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 60px;
    padding-top: 4rem;
    gap: 1rem;
    svg {
        align-self: flex-start;
    }
    @media screen and (max-width:382px) {
        svg {
            width: 45px;
            height: 35px;
        }
    }
    @media screen and (max-width:450px) {
        svg {
            width: 40px;
        }
    }
`
const Title = styled.h1`
font-weight: 700;
font-size: 40px;
line-height: 44px;
color: #FFFFFF;
margin-top: -0.5rem;
flex: 1;
@media screen and (max-width:500px) {
    font-size: 30px;
    }
    @media screen and (max-width:450px) {
        font-size: 24px;
    }
   
`
const Grid = styled.div
`
display: grid;
grid-template-columns: repeat(2,1fr);
gap:123px;
@media screen and (max-width:580px) {
    grid-template-columns: repeat(1,1fr);
    gap: 0px;
}

`
const GridBox = styled.div
`
margin-top:4rem;
    display: grid;
    grid-template-columns: repeat(3,1fr);
    
    
    gap:20px;
    @media screen and (max-width: 900px) {
        grid-template-columns: repeat(2,1fr);
        align-items: center;
        row-gap: 8rem;
    }
    @media screen and (max-width:650px) {
        grid-template-columns: repeat(1,1fr);

    }
`
const GridItemBox = styled.div`
height: -webkit-fill-available;
    padding:40px;
    border: 1px solid #D4DBE2;
border-radius: 32px;
height: 100%;
`
const GridItem = styled.p`
    font-weight: 300;
font-size: 24px;
line-height: 36px;
color: #FFFFFF;
opacity: 0.6;
@media screen and (max-width:400px) {
    font-size:16px;
    }
`
const GridParagraph = styled.p`
    font-weight: 400;
font-size: 16px;
line-height: 20px;
color: white;
opacity: 0.6;
`
const GridTitle = styled.h3`
font-weight: 600;
font-size: 24px;
line-height: 28px;
color: white;

`
const MoreWrap = styled.div`
    display:flex;
    margin-top: 4rem;
    gap: 4rem;
    flex-direction: row;
`
const Button = styled(Link)`
padding: 12px 24px;
font-weight: 400;
font-size: 14px;
line-height: 20px;
color: white;
background: #FF4C55;
font-family: 'Outfit';
font-style: normal;
border-radius: 32px;
@media screen and (max-width: 500px) {
   width: 100%
       text-align: center;
}
`
const LearnDiv = styled.div`
flex: 1;
position: relative;
@media screen and (max-width: 500px) {
    display: none;
}
    // &::after {
    //     content: '';
    //     position: absolute;
    //     width: 100%;
    //     height: 1px;
    //     background: #D4DBE2;
    //     top: 20px;
    // }
`
interface ExpertsProps {
    experts: any
}

const Experts: React.FC<ExpertsProps> = ({experts}) => {
    let location = ''
    let str = ''
    if( typeof window !== 'undefined')
    {
        location = window.location.pathname
        str = location.replace(/^\/([^\/]*).*$/, '$1')
    }
        return (
            <Wrap>
                <Wrapper>
            <TitleWrap>
                <Rects />
                <Title>{experts.title.text}</Title>
            </TitleWrap>
            <Grid>
                {experts.paragraphs.map((p: any)=>
            <GridItem>{p.paragraph.text}</GridItem>
                )}
            </Grid>
            <MoreWrap>
            <Button to={str== 'fr-fr' ? '/fr-fr/nos-services' : '/services'} className='pink'>Learn More</Button>
            <LearnDiv></LearnDiv>
            </MoreWrap>
            </Wrapper>

            </Wrap>
        );
}
export default Experts
